<template>
  <button
    :disabled="disabled"
    class="btn md__btn-primary"
    @click.prevent="handleClick"
  >
    {{ title }}
  </button>
</template>

<script>
export default {
  name: "ButtonPrimary",

  methods: {
    handleClick() {
      this.$emit("onClick");
    }
  },
  props: {
    title: {
      default: ""
    },
    disabled: {
      default: false
    }
  }
};
</script>

<style></style>
